import React, { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { EditorState } from 'draft-js';
import { htmlToDraft, draftToHtml } from 'utils/helpers';

export const withInjectedValue = (DraftEditorComponent) => {
  const FromDraftEditor = (props) => {
    const {
      onDraftEditorStateChange,
      onChange = () => {},
      value: propValue,
      ...draftEditorProps
    } = props;

    const [draftEditorState, setDraftEditorState] = useState(getDraftEditorState(propValue));

    const handleChange = (draftEditorState) => {
      setDraftEditorState(draftEditorState);
    };

    useEffect(() => {
      if (!onDraftEditorStateChange) {
        onChange(draftEditorState);
        return;
      }

      onDraftEditorStateChange(draftEditorState);
    }, [draftEditorState]);

    useEffect(() => {
      const newHtml = getHtml(propValue);

      if (propValue && !(propValue instanceof EditorState) && !propValue.html) {
        onChange({ ...propValue, html: newHtml });
      }

      setDraftEditorState((prevDraftEditorState) => {
        const html = draftToHtml(prevDraftEditorState);

        if (html === newHtml) {
          return prevDraftEditorState;
        }

        return getDraftEditorState(propValue);
      });
    }, [propValue]);

    return (
      <DraftEditorComponent
        {...draftEditorProps}
        value={draftEditorState}
        onChange={handleChange}
      />
    );
  };

  FromDraftEditor.propTypes = {
    ...DraftEditorComponent.propTypes,
  };

  const PossiblyInjectedValueEditor = (props) => {
    if (!DraftEditorComponent.isValueInjected) {
      return <FromDraftEditor {...props} />;
    }

    return <DraftEditorComponent {...props} />;
  };

  PossiblyInjectedValueEditor.propTypes = {
    ...FromDraftEditor.propTypes,
  };

  return PossiblyInjectedValueEditor;
};

const getDraftEditorState = (value) => {
  if (!isEmpty(value?.html)) {
    return htmlToDraft(value.html);
  }

  if (value instanceof EditorState) {
    return value;
  }

  return EditorState.createEmpty();
};

const getHtml = (value) => {
  if (value?.html) {
    return value.html;
  }

  if (value instanceof EditorState) {
    return draftToHtml(value);
  }

  return draftToHtml(EditorState.createEmpty());
};
